import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
		zone:  null,
		whois: null,
		dig:   null,
	},

	getters:
	{
		hasZone:    state => state && state.zone && !!state.zone.id,
		whoisError: state => state && state.whois === false,
		digError:   state => state && state.dig === false,
	},

	mutations:
	{
		[Types.ZONE_CLEAR](state)
		{
			state.zone = null
			state.file = null
		},

        [Types.ZONE_DETAILS](state, zone)
		{
            state.zone = zone
        },

        [Types.ZONE_MASTER_WHOIS](state, whois)
		{
            state.whois = whois
        },

        [Types.ZONE_MASTER_DIG](state, dig)
		{
            state.dig = dig
        },
	},

	actions:
	{
		[Types.ZONE_CLEAR]({ commit })
		{
			commit(Types.ZONE_CLEAR)
		},

		[Types.ZONE_DETAILS]({ commit, dispatch }, {zoneId})
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/zones/' + zoneId)
						.then
						(
							response =>
							{
								commit(Types.ZONE_DETAILS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_UPDATE]({ commit, dispatch }, { zoneId, data, router })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/zones/' + zoneId, data)
						.then
						(
							response =>
							{
								router.push({ name: 'zones' })
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_RECORD_CREATE]({ dispatch }, { zoneId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/zones/' + zoneId + '/records', data)
						.then
						(
							response =>
							{
								dispatch(Types.ZONE_DETAILS, { zoneId })
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_RECORD_UPDATE]({ dispatch }, { zoneId, zoneRecordId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/zones/' + zoneId + '/records/' + zoneRecordId, data)
						.then
						(
							response =>
							{
								dispatch(Types.ZONE_DETAILS, { zoneId })
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_RECORD_DELETE]({ dispatch }, { zoneId, zoneRecordId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.delete('/api/zones/' + zoneId + '/records/' + zoneRecordId, data)
						.then
						(
							response =>
							{
								dispatch(Types.ZONE_DETAILS, { zoneId })
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_MASTER_DIG]({ commit }, { zoneId, masterId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/zones/' + zoneId + '/ip-addresses/' + masterId + '/dig')
						.then
						(
							response =>
							{
								commit(Types.ZONE_MASTER_DIG, response.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_MASTER_WHOIS]({ commit }, { zoneId, masterId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/zones/' + zoneId + '/ip-addresses/' + masterId + '/whois')
						.then
						(
							response =>
							{
								commit(Types.ZONE_MASTER_WHOIS, response.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},
		
		[Types.ZONE_MASTER_CREATE]({ commit }, { zoneId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/zones/' + zoneId + '/ip-addresses', { data })
						.then(resolve)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_MASTER_UPDATE]({ commit }, { zoneMasterId, zoneId, data })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/zones/' + zoneId + '/ip-addresses/' + zoneMasterId, { data })
						.then(resolve)
						.catch(reject)
				}
			)
		},

		[Types.ZONE_MASTER_DELETE]({ commit }, { zoneId, zoneMasterId })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.delete('/api/zones/' + zoneId + '/ip-addresses/' + zoneMasterId)
						.then(resolve)
						.catch(reject)
				}
			)
		},
	},
}